export default __webpack_public_path__ + "static/media/Meme_content1.2907b10d.jpg";